<div class="register form-frame wide">
  <app-logo></app-logo>

  <form
    [formGroup]="form"
    (ngSubmit)="sendForm()"
    class="form-frame__body">

    <app-progress
      [percent]="'60'">
    </app-progress>

    <div class="form-frame__body-head">
      <app-back-button></app-back-button>
      <h2 class="headline">{{'ADDRESS_COMPANY_PAGE.TITLE' | translate}}</h2>
    </div>

    <p
      class="form-frame__body-description">
      {{'ADDRESS_COMPANY_PAGE.DESCRIPTION' | translate}}
    </p>

    <div class="form-frame__body-inputs">
      <div class="line">
        <div
          [class.error]="form.get('indexFormControl')?.invalid && form.get('indexFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="indexFormControl"
            id="index"
            mask="000000"
            inputmode="numeric"
            class="input"
            type="text"
            placeholder=" ">
          <label
            for="index"
            class="placeholder">
            {{'ADDRESS_COMPANY_PAGE.INDEX' | translate}}
          </label>
          <ng-container *ngIf="form.get('indexFormControl')?.invalid && form.get('indexFormControl')?.touched">
            <span
              *ngIf="indexRequiredError"
              class="input-block__error">
              {{'ADDRESS_COMPANY_PAGE.INDEX_REQUIRED' | translate}}
            </span>
            <span
              *ngIf="indexFormatError"
              class="input-block__error">
              {{'ADDRESS_COMPANY_PAGE.INDEX_INVALID' | translate}}
            </span>
          </ng-container>
        </div>

        <div
          [class.error]="form.get('cityFormControl')?.invalid && form.get('cityFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="cityFormControl"
            id="city"
            class="input"
            type="text"
            placeholder=" ">
          <label
            for="city"
            class="placeholder">
            {{'ADDRESS_COMPANY_PAGE.CITY' | translate}}
          </label>
          <ng-container *ngIf="form.get('cityFormControl')?.invalid && form.get('cityFormControl')?.touched">
            <span
              *ngIf="cityRequiredError"
              class="input-block__error">
              {{'ADDRESS_COMPANY_PAGE.CITY_REQUIRED' | translate}}
            </span>
          </ng-container>
        </div>
      </div>
      <div class="line">
        <div
          [class.error]="form.get('areaFormControl')?.invalid && form.get('areaFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="areaFormControl"
            id="area"
            class="input"
            type="text"
            placeholder=" ">
          <label
            for="area"
            class="placeholder">
            {{'ADDRESS_COMPANY_PAGE.AREA' | translate}}
          </label>
          <ng-container *ngIf="form.get('areaFormControl')?.invalid && form.get('areaFormControl')?.touched">
            <span
              *ngIf="areaRequiredError"
              class="input-block__error">
              {{'ADDRESS_COMPANY_PAGE.AREA_REQUIRED' | translate}}
            </span>
          </ng-container>
        </div>

        <div
          [class.error]="form.get('streetFormControl')?.invalid && form.get('streetFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="streetFormControl"
            id="street"
            class="input"
            type="email"
            placeholder=" ">
          <label
            for="street"
            class="placeholder">
            {{'ADDRESS_COMPANY_PAGE.STREET' | translate}}
          </label>
          <ng-container *ngIf="form.get('streetFormControl')?.invalid && form.get('streetFormControl')?.touched">
            <span
              *ngIf="streetRequiredError"
              class="input-block__error">
              {{'ADDRESS_COMPANY_PAGE.STREET_REQUIRED' | translate}}
            </span>
          </ng-container>
        </div>
      </div>
      <div class="line">
        <div
          [class.error]="form.get('houseFormControl')?.invalid && form.get('houseFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="houseFormControl"
            id="house"
            class="input"
            type="text"
            placeholder=" ">
          <label
            for="house"
            class="placeholder">
            {{'ADDRESS_COMPANY_PAGE.HOUSE' | translate}}
          </label>
          <ng-container *ngIf="form.get('houseFormControl')?.invalid && form.get('houseFormControl')?.touched">
            <span
              *ngIf="houseRequiredError"
              class="input-block__error">
              {{'ADDRESS_COMPANY_PAGE.HOUSE_REQUIRED' | translate}}
            </span>
          </ng-container>
        </div>

        <div
          [class.error]="form.get('officeFormControl')?.invalid && form.get('officeFormControl')?.touched"
          class="input-block">
          <input
            (input)="saveData()"
            formControlName="officeFormControl"
            id="office"
            class="input"
            type="email"
            placeholder=" ">
          <label
            for="office"
            class="placeholder">
            {{'ADDRESS_COMPANY_PAGE.OFFICE' | translate}}
          </label>
          <ng-container *ngIf="form.get('officeFormControl')?.invalid && form.get('officeFormControl')?.touched">
            <span
              *ngIf="officeRequiredError"
              class="input-block__error">
              {{'ADDRESS_COMPANY_PAGE.OFFICE_REQUIRED' | translate}}
            </span>
          </ng-container>
        </div>
      </div>

    </div>
    <button
      [disabled]="form.invalid"
      (click)="sendForm()"
      type="submit"
      class="btn btn-accent">
      {{'COMPANY_DATA_PAGE.CONTINUE' | translate}}
    </button>
  </form>

  <app-lang-select></app-lang-select>
</div>
